import { render } from "./PreviewImageCollection.vue?vue&type=template&id=63aac910&scoped=true"
import script from "./PreviewImageCollection.vue?vue&type=script&lang=js"
export * from "./PreviewImageCollection.vue?vue&type=script&lang=js"

import "./PreviewImageCollection.vue?vue&type=style&index=0&id=63aac910&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63aac910"]])

export default __exports__